import React from "react";
import MenuItem from "@mui/material/MenuItem";
import { Typography, Box } from "@mui/material";
import Menu from "./Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchIcon from "@mui/icons-material/Search";
import Field from "../Field/Fi";
import CheckIcon from "@mui/icons-material/Check";
const style = {
  margin: "4px 0px",
  marginBottom: "-8px",
  "&:hover": {
    color: "#255CCE",
    backgroundColor: "#fff",
  },
};

const currencies = [
  "New Zealand dollar (NZD)",
  "Australian dollar (AUD)",
  "Singapore dollar (SD)",
  "Brunei dollar (BRD)",
  "Libyan dinar (LID)",
  "Canadian dollar (CAD)",
  "United States dollar (USD)",
  "Swiss franc (SF)",
  "Euro (EU)",
  "Cayman Islands dollar (CID)",
  "Gibraltar pound (GP)",
  "Pound sterling (PS)",
  "Jordan dinar (JD)",
  "Omani rial (OR)",
  "Bahrain dinar (BD)",
  "Kuwaiti dinar (KD)",
  "New Zealand dollar (NZD)",
  "Singapore dollar (SD)",
  "Brunei dollar (BRD)",
  "Libyan dinar (LID)",
  "Cayman Islands dollar (CID)",
  "UAE Dirham (AED)",
].sort();

export default function Currency() {
  const [currentCurrency, setCurrentCurrency] = React.useState("AED");
  const [wordEntered, setWordEntered] = React.useState("");
  const [filteredData, setFilteredData] = React.useState(currencies);

  const handleChange = (curr) => () => {
    const idx = curr.indexOf("(");
    setCurrentCurrency(curr.substring(idx + 1, curr.length - 1));
  };

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);
    const newFilter = currencies.filter((value) => {
      return value.toLowerCase().includes(searchWord.toLowerCase());
    });
    if (searchWord === "") {
      setFilteredData([...currencies]);
    } else {
      setFilteredData(newFilter);
    }
  };

  return (
    <Menu
      text={currentCurrency}
      textVariant="subtitle2"
      buttonStyle={{ width: "68px", height: "20px", padding: "0px" }}
      textStyle={{ color: "text.primary" }}
      buttonVariant="text"
      icons={[<ArrowDropDownIcon />]}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      paperStyle={{
        width: "360px",
        maxHeight: "440px",
        borderRadius: "4px",
        marginTop: "10px",
        position: "relative",
      }}
    >
      <MenuItem
        sx={{
          position: "fixed",
          width: "326px",
          padding: "16px 0px 0px 0px !important",
          margin: "-8px 16px 0px",
          zIndex: "1",
          backgroundColor: "#fff !important",
          "&:hover": {
            backgroundColor: "#fff",
          },
        }}
        disableRipple
      >
        <Field
          label="Search Currency"
          borderColor="#DFDFDF"
          size="small"
          endIcon={<SearchIcon sx={{ color: "#808080" }} />}
          value={wordEntered}
          handleChange={handleFilter}
          transform="translate(7px,7px)"
          labelVariant="body2"
          labelFont="14px"
        ></Field>
      </MenuItem>
      <MenuItem
        disableRipple
        sx={{
          marginTop: "46px",
          "&:hover": {
            backgroundColor: "#fff",
          },
        }}
      >
        <Typography
          variant="caption"
          fontWeight="400"
          fontSize="12px"
          lineHeight="16px"
          color="#616161"
          sx={{ marginTop: "12px", paddingY: "0px", marginBottom: "-8px" }}
        >
          CURRENCIES
        </Typography>
      </MenuItem>
      {filteredData.map((currency) => {
        return (
          <MenuItem
            disableRipple
            sx={{
              ...style,
              color: currency.includes(currentCurrency) && "#4420A1",
            }}
            onClick={handleChange(currency)}
          >
            <Typography
              variant="body1"
              fontWeight="400"
              fontSize="16px"
              lineHeight="24px"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                fontWeight:
                  currency.includes(currentCurrency) && "700 !important",
              }}
            >
              {currency}
              {currency.includes(currentCurrency) && (
                <CheckIcon sx={{ fontSize: "16px", color: "#4420A1" }} />
              )}
            </Typography>
          </MenuItem>
        );
      })}
    </Menu>
  );
}
